export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper basic-content1-wrapper' },
  page: { className: 'home-page basic-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.basic.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'AUTOMOTIVE BASIC SOFTWARE'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.basic.introduce'
      }
    ],
  },
};
export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper basic-content2-wrapper' },
  page: { className: 'home-page basic-content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.basic.solution'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'SOLUTION'
      },
    ],
  },
  childWrapper: {
    className: 'basic-content2-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'basic-content2-block',
        active: true,
        title: 'product.basic.someIp',
        img: 'basic-01',
        children: {
          className: 'basic-content2-block-item',
          children: [
            {
              name: 'title',
              className: 'basic-content2-block-title',
              children: 'product.basic.someIp',
            },
            {
              name: 'sub-title',
              className: 'basic-content2-block-sub-title',
              children: 'product.basic.someIpSubTitle',
            },
            {
              name: 'content',
              className: 'basic-content2-block-content',
              title: 'product.basic.productFeature',
              children: 'product.basic.someIpContent',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'basic-content2-block',
        active: true,
        title: 'product.basic.doip',
        img: 'basic-02',
        children: {
          className: 'basic-content2-block-item',
          children: [
            {
              name: 'title',
              className: 'basic-content2-block-title',
              children: 'product.basic.doip',
            },
            {
              name: 'sub-title',
              className: 'basic-content2-block-sub-title',
              children: 'product.basic.doipSubTitle',
            },
            {
              name: 'content',
              className: 'basic-content2-block-content',
              title: 'product.basic.productFeature',
              children: 'product.basic.doipContent',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'basic-content2-block',
        active: true,
        title: 'product.basic.avbTsn',
        img: 'basic-03',
        children: {
          className: 'basic-content2-block-item',
          children: [
            {
              name: 'title',
              className: 'basic-content2-block-title',
              children: 'product.basic.avbTsn',
            },
            {
              name: 'sub-title',
              className: 'basic-content2-block-sub-title',
              children: 'product.basic.avbTsnSubTitle',
            },
            {
              name: 'content',
              className: 'basic-content2-block-content',
              title: 'product.basic.productFeature',
              children: 'product.basic.avbTsnContent',
            },
            {
              name: 'video',
              className: 'basic-content2-block-video-button',
              title: 'product.basic.videoIntroduction',
              children: 'AVB_TSN.mp4',
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'basic-content2-block',
        active: true,
        title: 'product.basic.fsCom',
        img: 'basic-04',
        children: {
          className: 'basic-content2-block-item',
          children: [
            {
              name: 'title',
              className: 'basic-content2-block-title',
              children: 'product.basic.fsCom',
            },
            {
              name: 'sub-title',
              className: 'basic-content2-block-sub-title',
              children: 'product.basic.fsComSubTitle',
            },
            {
              name: 'content',
              className: 'basic-content2-block-content',
              title: 'product.basic.productFeature',
              children: 'product.basic.fsComContent',
            },
          ],
        },
      },
    ],
  },
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper basic-content3-wrapper' },
  page: { className: 'home-page basic-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.basic.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ],
  },
  childWrapper: {
    className: 'basic-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'basic-content3-block',
        active: true,
        children: {
          className: 'basic-content3-block-item',
          img: 'basic-05.png',
          title: 'product.basic.conventionalController',
          children: [
            {
              name: 'content',
              className: 'basic-content3-block-content',
              children: 'product.basic.conventionalControllerContent',
            }
          ],
        },
      },
      {
        name: 'block1',
        className: 'basic-content3-block',
        active: true,
        children: {
          className: 'basic-content3-block-item',
          img: 'basic-06.png',
          title: 'product.basic.domainController',
          children: [
            {
              name: 'content',
              className: 'basic-content3-block-content',
              children: 'product.basic.domainControllerContent',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'basic-content3-block',
        active: true,
        children: {
          className: 'basic-content3-block-item',
          img: 'basic-07.png',
          title: 'product.basic.vehicleNetworkDesign',
          children: [
            {
              name: 'content',
              className: 'basic-content3-block-content',
              children: 'product.basic.vehicleNetworkDesignContent',
            }
          ],
        },
      }
    ],
  },
};
